import logoImg from "@public/logo/logo.jpeg";
import { LAYOUT_OPTIONS } from "@/config/enums";
import logoIconImg from "@public/logo/logo.jpeg";

enum MODE {
    DARK = "dark",
    LIGHT = "light",
}

export const siteConfig = {
    title: "Afro Cargo",
    description: `Afro Cargo is a logistics company that provides a wide range of services including air freight, sea freight, road freight, warehousing, and customs clearance. We are a one-stop solution for all your logistics needs.`,
    logo: logoImg,
    icon: logoIconImg,
    mode: MODE.DARK,
    layout: LAYOUT_OPTIONS.HYDROGEN,
    // TODO: favicon
};

export const metaObject = (
    title: string = siteConfig.title,
    description: string = siteConfig.description,
) => {
    const pageTitle =
        title.trim().toLowerCase() === siteConfig.title.toLowerCase()
            ? siteConfig.title
            : `${title} - ${siteConfig.title}`;

    return {
        title: pageTitle,
        description,
        openGraph: {
            title: pageTitle,
            description,
            url: "https://afrocargo.com",
            siteName: "Afro Cargo",
            images: {
                url: "https://afrocargo.com/images/og-image.png",
                width: 1200,
                height: 630,
            },
            locale: "en_US",
            type: "website",
        },
    };
};
